import { getEnumValue } from '@philips-internal/oswald-ui-utils';
import { ComponentType } from '../component-type.js';
import { SimpleCatalog } from './simple-catalog.js';
class TypedCatalog {
    constructor() {
        this.catalog = new SimpleCatalog('');
        Object.keys(ComponentType)
            .forEach(key => {
            const type = getEnumValue(ComponentType, key);
            this.catalog.set(type, new SimpleCatalog(type));
        });
    }
    /**
     * Retrieves the registry for a given component type.
     *
     * @param type - Component type.
     */
    get(type) {
        return this.catalog.get(type);
    }
    /**
     * Checks whether a component type has a registry associated with it.
     *
     * @param type - Component type.
     */
    has(type) {
        return this.catalog.has(type);
    }
}
export { TypedCatalog, };
//# sourceMappingURL=typed-catalog.js.map